import { render, staticRenderFns } from "./ShowNpc.vue?vue&type=template&id=28e9c022&scoped=true"
import script from "./ShowNpc.vue?vue&type=script&lang=js"
export * from "./ShowNpc.vue?vue&type=script&lang=js"
import style0 from "./ShowNpc.vue?vue&type=style&index=0&id=28e9c022&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e9c022",
  null
  
)

export default component.exports